import http from '@/uteis/http'

export default class NumeroProcessoService {
  async buscarTipoInteressados () {
    const url = '/d0593/pae-back/v1/dadosFixos/tipo/interessado?situacao=ATIVO'

    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarTiposProcessos () {
    const url = '/d0593/pae-back/v1/dadosFixos/tipo/processo'

    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarMotivos () {
    const url = '/d0593/pae-back/v1/dadosFixos/motivo'

    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarEspecieIdAssunto (idAssunto) {
    const url = '/d0593/pae-back/v1/dadosFixos/buscarEspeciePorIdAssunto'
    return new Promise((resolve, reject) => {
      http.get(url, { params: { idAssunto } }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarEspeciePorId (codigoEspecie) {
    const url = '/d0593/pae-back/v1/dadosFixos/buscarEspeciePorId'
    return new Promise((resolve, reject) => {
      http.get(url, { params: { codigoEspecie } }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarEspeciePorCodigo (codigoEspecie, idOrgao) {
    const url = '/d0593/pae-back/v1/dadosFixos/buscarEspeciePorCodigo'
    return new Promise((resolve, reject) => {
      http.get(url, { params: { idOrgao, codigoEspecie } })
        .then((response) => resolve(response.data))
        .catch(err => {
          if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
            return reject(err)
          }
          console.log('ERROOOOO ->', err)
          http.get(url)
            .then((response) => resolve(response.data))
            .catch(() => reject(err))
        })
    })
  }

  async buscarAssunto (query) {
    const url = '/d0593/pae-back/v1/dadosFixos/assunto'
    return new Promise((resolve, reject) => {
      http.get(url, { params: query })
        .then((response) => resolve(response.data))
        .catch(err => {
          if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
            return reject(err)
          }
          console.log('ERROOOOO ->', err)
          http.get(url)
            .then((response) => resolve(response.data))
            .catch(() => reject(err))
        })
    })
  }
}
